module.exports = __webpack_public_path__ + "static/media/raduno2000.de35fc2a.jpg";